let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("6aUfU")]).then(() => parcelRequire('it8QE'));